import BankboxManager from "@ravenpay/bankbox-me-sdk/bundles/index.esm.js";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeRavenPayment,
  resetHasCompletedPayment,
  resetPopUpRaven,
  setRavenCredential,
} from "../store/modules/payments";
import { cleanObject } from "../helpers";

export const useRavenPayment = ({ allowMount = false }) => {
  const bankboxRef = useRef(null);
  const { raven } = useSelector((state) => state.paymentsReducer);
  const dispatch = useDispatch();

  // Ref to keep the latest raven value accessible in onSuccess
  const ravenRef = useRef(raven);

  // Sync ref with latest raven on every render
  useEffect(() => {
    ravenRef.current = raven;
  }, [raven]);

  // Handle pop-up trigger
  useEffect(() => {
    if (raven?.popUpRaven) {
      handlePayment({ amount: raven?.amount, email: raven?.business_email });
      dispatch(resetPopUpRaven());
    }
  }, [raven?.popUpRaven]);

  // Reset payment completion flag
  useEffect(() => {
    if (raven?.hasCompletedPayment) dispatch(resetHasCompletedPayment());
  }, [raven?.hasCompletedPayment]);

  // Initialize BankboxManager
  useEffect(() => {
    if (!allowMount) return;

    bankboxRef.current = new BankboxManager({
      appName: "lumi",
      environment: process.env.REACT_APP_RAVEN_ENV,
      widgetOptions: {
        isPersistent: true,
      },
      onSuccess: (data) => {
        // Use ravenRef.current instead of raven directly
        console.log(data);
        dispatch(
          setRavenCredential({
            rrn: data?.rrn || data?.session_id,
            paymentType: "raven",
          }),
        );
        dispatch(closeRavenPayment());

        if (!ravenRef.current?.allowFeedBack) bankboxRef?.current?.close();
      },
      onLoad: () => {
        console.log("Bankbox is ready");
      },
      onError: (error) => {
        console.error("An error occurred:", error);
      },
    });

    // Cleanup
    return () => {
      if (bankboxRef?.current) {
        bankboxRef.current = null;
      }
    };
  }, [allowMount]);

  // Trigger payment manually
  const handlePayment = ({ amount = null, email = null }) => {
    const obj = amount || email ? cleanObject({ amount, email }) : undefined;
    console.log(obj);
    if (!obj) return bankboxRef?.current?.open();

    bankboxRef?.current?.$event.emit(
      bankboxRef?.current?.constants.sdkPaymentData,
      obj,
    );

    bankboxRef?.current?.open(obj);
  };

  return {
    bankbox: bankboxRef?.current,
    handlePayment,
  };
};
